import coefficients from './genre-coefficients.json';

export function createMusicTest() {
  const test = document.createElement('details');
  test.className = 'music-test';
  const genres = ['Alternative', 'Classical music', 'Dance', 'Hiphop, Rap', 'Pop', 'Rock'];
  const traits = ['Openness', 'Conscientiousness', 'Extraversion', 'Agreeableness', 'Neuroticism'];
  const meanings = {
    Openness: ['curiosity & new experiences', 'a greater preference for new ideas and experiences', 'a greater preference for familiarity and practical choices'],
    Conscientiousness: ['structure & follow-through', 'a stronger tendency toward planning and organisation', 'a stronger preference for flexibility over structure'],
    Extraversion: ['social energy', 'a stronger preference for social interaction and stimulation', 'a stronger preference for quiet environments and independent activities'],
    Agreeableness: ['cooperation & directness', 'a stronger tendency toward cooperation and compromise', 'a more direct and assertive interpersonal style'],
    Neuroticism: ['emotional sensitivity', 'greater sensitivity to stress and emotional changes', 'greater emotional stability under stress'],
  };
  test.innerHTML = '<summary>🧪 TEST YOUR TASTE</summary><p>Rate your preference for each genre: 1 = strongly dislike, 3 = neutral, 5 = strongly like.</p>';
  const form = document.createElement('form');
  genres.forEach((genre, index) => {
    const label = document.createElement('label');
    label.htmlFor = `genre-${index}`;
    label.textContent = genre;
    const input = document.createElement('input');
    input.id = label.htmlFor;
    input.type = 'range'; input.min = '1'; input.max = '5'; input.step = '1'; input.value = '3';
    input.dataset.genre = genre;
    const value = document.createElement('output');
    value.textContent = '3'; value.htmlFor = input.id;
    input.addEventListener('input', () => { value.textContent = input.value; });
    label.append(input, value);
    form.append(label);
  });
  const submit = document.createElement('button');
  submit.type = 'submit'; submit.className = 'cta-btn'; submit.textContent = 'RUN THE EXPERIMENT →';
  form.append(submit);
  const results = document.createElement('div');
  results.className = 'taste-results'; results.setAttribute('aria-live', 'polite');
  form.addEventListener('submit', event => {
    event.preventDefault(); results.replaceChildren();
    const breakdown = document.createElement('h4');
    breakdown.className = 'taste-breakdown-heading';
    breakdown.textContent = 'What the model suggests based on your preferences';
    results.append(breakdown);
    const shifts = [];
    traits.forEach(trait => {
      const delta = [...form.querySelectorAll('input')].reduce((sum, input) => {
        const row = coefficients.find(item => item.Genre === input.dataset.genre);
        return sum + (Number(input.value) - 3) * Number(row[trait]);
      }, 0);
      shifts.push({ trait, delta });
      const line = document.createElement('div');
      line.className = 'taste-result';
      const name = document.createElement('strong'); name.textContent = `${trait} · ${meanings[trait][0]}`;
      const score = document.createElement('span'); score.textContent = `${delta >= 0 ? '+' : ''}${delta.toFixed(2)} points`;
      const interpretation = document.createElement('p');
      interpretation.textContent = Math.abs(delta) < 0.005
        ? 'Your ratings produce little change in this trait estimate.'
        : (() => { const description = meanings[trait][delta > 0 ? 1 : 2].replace(/^a /, ''); return description.charAt(0).toUpperCase() + description.slice(1) + '.'; })();
      line.append(name, score, interpretation); results.append(line);
    });
    const takeaway = document.createElement('div');
    takeaway.className = 'taste-takeaway';
    const heading = document.createElement('h4'); heading.textContent = 'RESULTS SUMMARY';
    const text = document.createElement('p');
    const strongest = shifts.slice().sort((a, b) => Math.abs(b.delta) - Math.abs(a.delta))[0];
    text.textContent = Math.abs(strongest.delta) < 0.005
      ? 'Your ratings produce no substantial change from the neutral baseline.'
      : `The largest shift concerns ${meanings[strongest.trait][0]}: the model suggests ${meanings[strongest.trait][strongest.delta > 0 ? 1 : 2]}.`;
    takeaway.append(heading, text); results.prepend(takeaway);
  });
  const note = document.createElement('p');
  note.className = 'preview-note';
  note.textContent = 'These are exploratory associations, not a validated personality assessment; scores represent changes from neutral genre preferences, not absolute trait levels.';
  test.append(form, results, note);
  return test;
}
